export default __webpack_public_path__ + "static/media/clip.f11cbbc7.svg";